// 动态加载 UDC SDK（npm import 可能为 undefined，改用 CDN）
;(function loadUdcScript() {
  if (window.TAL_UC) return
  var s = document.createElement('script')
  s.src = process.env.NODE_ENV === 'production'
    ? 'https://ucres.100tal.com/libs/jssdk/passport@1.27.08/passport.js?t=20210818'
    : 'https://test-ucres.100tal.com/libs/jssdk/passport@1.27.08/passport.js?t=20190918'
  s.async = false
  document.head.appendChild(s)
})()

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Meta from 'vue-meta'
import axios from 'axios'
import Service from '@/service/service'
import 'element-ui/lib/theme-chalk/index.css'
// import '~common/assets/css/default.css'
import {
  Carousel,
  CarouselItem,
  Cascader,
  Pagination,
  Select,
  Option,
  Radio,
  Input,
  Popover,
  Tabs,
  TabPane,
  Tooltip,
  Form,
  FormItem,
  Button,
  Message,
  MessageBox
} from 'element-ui'
Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tabs)
Vue.use(Tooltip)
Vue.use(TabPane)
Vue.use(Meta)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Cascader)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Popover)

Vue.prototype.$http = axios
Vue.prototype.Service = Service
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./module/forgetPassword/src/main.js